// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveMin } from '../models/ApiWaveMin';
import { HttpFile } from '../http/http';

export class ApiMentionedWave {
    'wave_name_in_content': string;
    'wave_id': string;
    'wave'?: ApiWaveMin;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "wave_name_in_content",
            "baseName": "wave_name_in_content",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave_id",
            "baseName": "wave_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave",
            "baseName": "wave",
            "type": "ApiWaveMin",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiMentionedWave.attributeTypeMap;
    }

    public constructor() {
    }
}
